import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import FooterTwo from '../components/Layout/Footer/FooterStyleTwo';
import logo from '../assets/images/artwer/logo-dark-text.png';

// Minimal, ART-WER-branded 404 (replaces the old demo header/breadcrumb/error chrome,
// which also dropped the last Font Awesome dependency).
const NoPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.paddingTop = '';
  }, []);

  return (
    <div className="homestyle2">
      <header className="artwer-subpage-header">
        <div className="container">
          <Link to="/" aria-label="ART-WER — naar home">
            <img src={logo} className="artwer-subpage-logo" alt="ART-WER Aannemingsbedrijf" />
          </Link>
          <Link to="/" className="thm-btn-two artwer-subpage-back">Naar home</Link>
        </div>
      </header>

      <section className="artwer-legal-page" style={{ textAlign: 'center', minHeight: '46vh' }}>
        <div className="container">
          <h1>Pagina niet gevonden</h1>
          <p>De pagina die u zoekt bestaat niet (meer). Ga terug naar de homepage of neem contact op.</p>
          <p style={{ marginTop: '26px' }}>
            <Link to="/" className="thm-btn-two">Naar de homepage</Link>
          </p>
        </div>
      </section>

      <FooterTwo />
    </div>
  );
};

export default NoPage;
